import { render } from "./chatright.vue?vue&type=template&id=2eece8a8&scoped=true"
import script from "./chatright.vue?vue&type=script&lang=js"
export * from "./chatright.vue?vue&type=script&lang=js"

import "./chatright.vue?vue&type=style&index=0&id=2eece8a8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eece8a8"]])

export default __exports__